import React, { useState } from "react";
import SuggestedTeamDropdown from "./suggested-team-dropdown";
import TeamsSearchbar from "./teams-searchbar";
import Button from "atoms/buttons/button";
import { ButtonStyles } from "atoms/constants/button-styles";
import { ButtonSizes } from "atoms/constants/button-sizes";
import { useParams } from "react-router";
import BaseModalFooter from "molecules/modals/footers/base-modal-footer";
import { t } from "utilities/localization-utils";
import AlertBanner from "molecules/alerts/alert-banner";
import AlertLevels from "constants/alert-levels";

const CSS_CLASS_NAME = "c-support-user-team-manage-modal";
interface ModalPhaseFindTeamProps {
    onTeamIdChange: (id: number | undefined) => void;
    selectedTeamId: number | undefined;
    onNext: () => void;
}

const ModalPhaseFindTeam = (props: ModalPhaseFindTeamProps) => {
    const { onTeamIdChange, selectedTeamId, onNext } = props;
    const { id: ownerIdFromParams } = useParams<{ id: string }>();
    const ownerId = parseInt(ownerIdFromParams);
    const [isUsingGeneralTeamSearch, setIsUsingGeneralTeamSearch] =
        useState(false);

    const hangleToggleIsUsingGeneralTeamSearch = () => {
        onTeamIdChange(undefined);
        setIsUsingGeneralTeamSearch(!isUsingGeneralTeamSearch);
    };

    return (
        <div className={CSS_CLASS_NAME}>
            <div className={`${CSS_CLASS_NAME}__content`}>
                <AlertBanner alertLevel={AlertLevels.Info}>
                    Use this flow to migrate a team to a new subscription. You
                    can select a team owned by this user before, or search LiNK
                    for any team.
                </AlertBanner>
                <br />
                {isUsingGeneralTeamSearch ? (
                    <>
                        <TeamsSearchbar
                            onTeamClick={onTeamIdChange}
                            selectedTeamId={selectedTeamId}
                        />
                        <div
                            className={`${CSS_CLASS_NAME}__selection-toggle-button`}>
                            <Button
                                cssClassName={`${CSS_CLASS_NAME}__selection-toggle-button`}
                                size={ButtonSizes.Medium}
                                style={ButtonStyles.AnchorBlue}
                                onClick={hangleToggleIsUsingGeneralTeamSearch}>
                                Or, select one of this user's previously owned
                                teams
                            </Button>
                        </div>
                    </>
                ) : (
                    <>
                        <SuggestedTeamDropdown
                            ownerId={ownerId}
                            onChangeTeam={onTeamIdChange}
                        />
                        <div
                            className={`${CSS_CLASS_NAME}__selection-toggle-button`}>
                            <Button
                                cssClassName={`${CSS_CLASS_NAME}__selection-toggle-button`}
                                size={ButtonSizes.Medium}
                                style={ButtonStyles.AnchorBlue}
                                onClick={hangleToggleIsUsingGeneralTeamSearch}>
                                Or, search for a team by team name or owner
                                email address
                            </Button>
                        </div>
                    </>
                )}
            </div>
            <BaseModalFooter
                primaryText={t("next")}
                primaryButtonProps={{
                    onClick: onNext,
                    disabled: !selectedTeamId,
                }}
                closeDialog={() => {}}
            />
        </div>
    );
};

export default ModalPhaseFindTeam;
